import { Link } from "react-router-dom";
import { Music, Users, ShieldCheck } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1720186576697-24c1496a07e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxjaG9pciUyMHNpbmdpbmclMjBjaGlsZHJlbiUyMHBlcmZvcm1hbmNlfGVufDB8fHx8MTc4ODk4MDk0MXww&ixlib=rb-4.1.0&q=85";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#0B192C] text-[#FAF7EE]" data-testid="landing-page">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-25">
          <img src={HERO_IMG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B192C]/60 via-[#0B192C]/85 to-[#0B192C]" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 pt-14 pb-20 sm:pt-20 sm:pb-28">
          <div className="flex items-center gap-2 text-[#C69B3D]">
            <Music className="w-5 h-5" aria-hidden />
            <span className="text-xs font-bold uppercase tracking-[0.25em]">ChoirQuest</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-6 leading-tight" data-testid="landing-heading">
            Music Theory &amp; Musicianship<br className="hidden sm:block" /> for Young Singers
          </h1>
          <p className="mt-5 max-w-xl text-base sm:text-lg text-[#FAF7EE]/80 leading-relaxed">
            Theory practice they actually want to do. Progress you can actually see.
            Short Challenges, Notes to earn, Quests from your choir team — on any device.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 max-w-2xl">
            <Link to="/play" data-testid="chorister-login-cta"
              className="flex-1 text-center px-8 py-4 rounded-2xl bg-[#C69B3D] text-[#0B192C] font-bold text-lg hover:bg-[#D8AB49] transition-colors min-h-[52px]">
              I'm a Chorister
            </Link>
            <Link to="/signup" data-testid="start-trial-cta"
              className="flex-1 text-center px-8 py-4 rounded-2xl bg-[#FAF7EE] text-[#0B192C] font-bold text-lg hover:bg-white transition-colors min-h-[52px]">
              Start a free trial
            </Link>
            <Link to="/staff" data-testid="staff-login-cta"
              className="flex-1 text-center px-8 py-4 rounded-2xl border-2 border-[#C69B3D]/60 text-[#FAF7EE] font-bold text-lg hover:border-[#C69B3D] hover:bg-white/5 transition-colors min-h-[52px]">
              Staff Sign In
            </Link>
          </div>
          <p className="mt-3 text-xs text-[#FAF7EE]/50">14-day trial · up to 15 choristers · no card required</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-14 grid gap-6 sm:grid-cols-3">
        {[
          { icon: Music, title: "Game-like learning", body: "Challenges, Daily Notes, Quests and Mastery — built for cathedral choristers, school choirs and youth choirs alike." },
          { icon: Users, title: "For every choir", body: "Directors choose the modules their singers need. Specialist areas like Psalms & Anglican Chant appear only where relevant." },
          { icon: ShieldCheck, title: "Private by design", body: "No child emails, no chat, no public leaderboards. Progress belongs to the chorister and syncs across every device." },
        ].map(({ icon: Icon, title, body }) => (
          <div key={title} className="rounded-2xl border border-[#1E3A5F] bg-[#12253E] p-6">
            <Icon className="w-6 h-6 text-[#C69B3D]" aria-hidden />
            <h2 className="font-display text-lg font-semibold mt-3">{title}</h2>
            <p className="text-sm text-[#FAF7EE]/70 mt-2 leading-relaxed">{body}</p>
          </div>
        ))}
      </div>

      <footer className="border-t border-[#1E3A5F]">
        <div className="max-w-5xl mx-auto px-6 py-8 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between text-xs text-[#FAF7EE]/50">
          <span>© {new Date().getFullYear()} ChoirQuest. An independent music learning resource.</span>
          <Link to="/privacy" className="underline hover:text-[#C69B3D]" data-testid="privacy-link">Privacy for children &amp; adults</Link>
        </div>
      </footer>
    </div>
  );
}
